import { render, staticRenderFns } from "./TodayDeleteList.vue?vue&type=template&id=24aa1842&scoped=true"
import script from "./TodayDeleteList.vue?vue&type=script&lang=js"
export * from "./TodayDeleteList.vue?vue&type=script&lang=js"
import style0 from "./TodayDeleteList.vue?vue&type=style&index=0&id=24aa1842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa1842",
  null
  
)

export default component.exports